<template>
  <div>
    <div
      v-if="title && showBar"
      class="content-searcher-titulo"
    >
      <span data-testid="content-searcher-title">{{ title }}</span>
      <span
        v-if="required"
        class="text-color-red"
      > *</span>
    </div>
    <!-- control for entity advancement -->
    <div
      v-if="showBar"
      class="content-searcher-erp"
      :class="[
        {
          'disabled-component': disabled,
          'disabled-component-no-opacity': noOpacityDisabled,
        },
      ]"
    >
      <div v-if="nextAndPreviousButtonsShown">
        <div
          class="content-searcher-erp__arrow-btn"
          @click="PreviousEntity"
        >
          <img
            src="@/static/icons/ic_left_arrow.svg"
            width="20px"
            height="20px"
          >
        </div>
      </div>
      <div class="content-searcher-erp-group">
        <div
          class="content-searcher-erp__input"
          :class="[
            {
              'disabled-component': disabled,
              'disabled-component-no-opacity': noOpacityDisabled,
            },
          ]"
        >
          <form
            class="content-search-input"
            @submit.prevent="showBtnSearch && searchFieldValue !== '' ? ValidateEntity(autoFocusOnEmptySearchResult) : undefined"
          >
            <div
              class="input-search"
              @click="HandleInputClick"
            >
              <input
                :id="inputElementId"
                type="text"
                class="truncate"
                data-testid="search-input-element-id"
                :autofocus="focusOnInput"
                :placeholder="placeholder"
                :value="searchFieldValue"
                :disabled="disableInput"
                :inputmode="inputmode"
                @change="ValidatingMode"
                @input="searchFieldValue = $event.target.value; emitFieldValue()"
              >
            </div>

            <div
              v-if="showWarningInput"
              class="input-search-icon"
            >
              <img
                src="@/static/icons/ic_warning.svg"
                width="20px"
                height="20px"
              >
            </div>

            <div
              v-if="showBtnSearch"
              class="input-search-icon"
              @click="ClickInputButton()"
            >
              <img
                v-show="componentMode === states.SEARCH || componentMode === states.VALIDATING"
                class="input-search-icon__search"
                src="@/static/icons/ic_search.svg"
                width="20px"
                height="20px"
              >
              <img
                v-show="componentMode === states.VALIDATED"
                class="input-search-icon__cancel"
                src="@/static/icons/ic_cancel.svg"
                width="12px"
                height="12px"
              >
            </div>
          </form>
        </div>
        <div
          v-if="qrSearchShow && qrSearchParams.showInputButton"
          class="div-qr-search"
          @click="OpenQRSearch()"
        >
          <img
            class="div-qr-search__img"
            :class="{ 'disabled-component': disabledQr }"
            src="@/static/icons/qr-code.svg"
          >
        </div>
      </div>
      <div v-if="nextAndPreviousButtonsShown">
        <!-- control for entity advancement -->
        <div
          class="content-searcher-erp__arrow-btn"
          @click="NextEntity"
        >
          <img
            src="@/static/icons/ic_right_arrow.svg"
            width="20px"
            height="20px"
          >
        </div>
      </div>
    </div>

    <!-- Popup Search entityList -->
    <f7-popup
      v-model:opened="popupSearchEntities"
      class="Search-popup"
      @popup:closed="popupSearchEntities && Clear({ keepSelection: true })"
    >
      <div class="page">
        <TheNavbar
          :nav-title="title"
          popup-close-btn-enable
        />

        <!-- <f7-searchbar
          search-container=".container-filter"
          :search-in="searchInString"
          :placeholder="searchFieldValue"
          :value="searchFieldValue"
        /> -->
        <f7-page-content id="search-entity-page-content">
          <div
            class="container-master"
            :class="{
              'total-elements-shown': showTotalElements,
              'total-elements-hidden': !showTotalElements,
            }"
          >
            <div class="container">
              <input
                class="container__filter-input margin-right"
                type="text"
                :placeholder="$t('common.searchEllipsis')"
                :value="searchTextFilter"
                @input="ChangeSearch($event.target.value)"
              >

              <div
                v-if="searchTextFilter === ''"
                class="container__img"
              >
                <img
                  src="@/static/icons/ic_search.svg"
                  width="24px"
                  height="24px"
                >
              </div>
              <f7-button
                v-else
                class="container__img"
                @click="ChangeSearch('')"
              >
                <f7-icon
                  f7="arrow_left"
                  size="30px"
                  color="grey"
                />
              </f7-button>
            </div>
            <div class="cantidad-elementos">
              <span v-if="showTotalElements">
                {{
                  $t('searchEntityERP.totalElements', {
                    current: items.length,
                    total: entityList != null ? entityList.length : '0',
                  })
                }}
              </span>
            </div>
          </div>
          <f7-list class="search-list searchbar-not-found">
            <f7-list-item
              :id="inputElementId"
              :title="searchNotFoundText"
            />
          </f7-list>

          <f7-list
            media-list
            class="search-list searchbar-found content-list-search listaConBusqueda"
            :class="{ 'search-list__has-bottom-bar': showPaginationBar || multiSelection }"
          >
            <f7-list-item
              v-for="entity in items"
              :key="entity.Id"
              @click="multiSelection ? SelectEntity(entity, true, true) : SelectEntity(entity, true)"
            >
              <slot name="title">
                <div class="item-title display-flex flex-direction-row align-items-center justify-content-space-between">
                  <div>
                    <label
                      v-if="multiSelection"
                      class="checkbox margin-right"
                    >
                      <input
                        :checked="entity.checked"
                        type="checkbox"
                        @change="ChangeCheckBox(entity)"
                      >
                      <i class="icon-checkbox" />
                    </label>
                    <span>{{ GetPropertyEntityShownListTitle(entity) }}</span>
                  </div>

                  <div v-if="$slots['after-title']">
                    <slot
                      name="after-title"
                      :item="entity"
                    />
                  </div>
                </div>
              </slot>
              <slot
                name="subtitle"
              >
                <div
                  class="subtitle-box margin-top-half"
                  :class="{ 'subtitle-box-column': (useMoodColumnsSubtitle) }"
                >
                  <div
                    v-for="(item, index) in GetPropertyEntityShownListSubtitle(entity)"
                    :key="index"
                    :class="`subtitle${index}`"
                  >
                    <slot
                      :name="`subtitle-${index}`"
                      :item="item"
                    >
                      <div
                        v-if="item"
                        class="subtitle-element subtitle-element"
                        :class="{ 'subtitle-element-column': useMoodColumnsSubtitle }"
                      >
                        <div
                          v-if="useMoodColumnsSubtitle"
                          class="subtitle-prefix-column"
                        >
                          {{
                            item.toString().includes(' - ')
                              ? preListItemsShowSubtitle[index].replace(':', ' - ') + (preListItemsShowSubtitle[index + 1] || '')
                              : preListItemsShowSubtitle[index]
                          }}
                        </div>
                        <div
                          v-if="!useMoodColumnsSubtitle && preListItemsShowSubtitle[index] !== ''"
                          class="subtitle-prefix"
                        >
                          {{ preListItemsShowSubtitle[index] }}
                        </div>
                        <div
                          v-if="!useMoodColumnsSubtitle"
                          :class="`subtitle${index}`"
                        >
                          {{ item.toString().replace(' - ', ` - ${preListItemsShowSubtitle[index + 1] || ''} `) }}
                        </div>

                        <div
                          v-else
                          :class="`subtitle${index}`"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </slot>
                  </div>
                </div>
              </slot>
              <slot
                name="footer"
                :item="entity"
              />
            </f7-list-item>
            <!--          <div
              v-if="loading && entityList !== null && items.length <= entityList.length "
              class="loader-container"
            >
              <div class="loader" />
            </div> -->
            <div
              v-if="showPaginationBar || multiSelection"
              class="pagination-bar"
              :class="showPaginationBar && multiSelection ? 'pagination-bar-height' : ''"
              data-testid="ucsearch-pagination-bar"
            >
              <div
                v-if="showPaginationBar"
                class="display-flex align-items-center"
              >
                <f7-button
                  :disabled="currentPageNum <= 1"
                  @click="SetNewItemsPage(1)"
                >
                  <img
                    alt="Primera página"
                    class="pagination-bar__reversed-image"
                    src="@/static/icons/btn-next.svg"
                    width="24"
                  >
                </f7-button>
                <f7-button
                  :disabled="currentPageNum <= 1"
                  @click="ChangeItemsPage(false)"
                >
                  <img
                    alt="Atrás"
                    class="pagination-bar__reversed-image"
                    src="@/static/icons/btn-next.svg"
                    width="32"
                  >
                </f7-button>
                <div class="display-flex align-items-center margin-left-half margin-right-half">
                  <input
                    type="number"
                    :min="1"
                    :max="totalPagesNum"
                    :placeholder="currentPageNum"
                    :value="findPageValue"
                    :disabled="totalPagesNum <= 1"
                    @change="SetNewItemsPage(findPageValue)"
                    @input="findPageValue = $event.target.value"
                  >
                  <span class="pagination-bar__total-pages">
                    {{ `/ ${totalPagesNum}` }}
                  </span>
                </div>
                <f7-button
                  :disabled="currentPageNum === totalPagesNum"
                  @click="ChangeItemsPage(true)"
                >
                  <img
                    alt="Siguiente"
                    src="@/static/icons/btn-next.svg"
                    width="32"
                  >
                </f7-button>
                <f7-button
                  :disabled="currentPageNum === totalPagesNum"
                  @click="SetNewItemsPage(totalPagesNum)"
                >
                  <img
                    alt="Última página"
                    src="@/static/icons/btn-next.svg"
                    width="24"
                  >
                </f7-button>
              </div>
              <div v-if="multiSelection">
                <f7-button
                  fill
                  class="margin-left"
                  small
                  :disabled="disabledButton"
                  @click="SelectedElements()"
                >
                  {{ $t('common.select') }}
                </f7-button>
              </div>
              <!-- <div
                v-if="entityList"
                class="display-flex margin-left"
              >
                Total: {{ `${items.length} / ${lstFiltrada.length > 0 ? lstFiltrada.length : entityList.length}` }}
              </div> -->
            </div>
          </f7-list>

          <!-- <div>
            <virtual-list
              :size="itemSize"
              :remain="remain"
              :bench="bench"
              :items="items"
            >
              <template #item="{ item }">
                <div>
                  {{ item.name }}
                </div>
              </template>
            </virtual-list>
          </div> -->
        </f7-page-content>
      </div>
    </f7-popup>
    <UCCodeScanner
      v-if="qrSearchShow"
      ref="componentUCcodeScanner"
      :fab-button-show="qrSearchParams.fabButtonShow"
      :fab-button-background-color="qrSearchParams.fabButtonBackgroundColor"
      :fab-button-min-width="qrSearchParams.fabButtonMinWidth"
      :fab-button-text="qrSearchParams.fabButtonText"
      :allow-manual-code-entry="qrSearchParams.allowManualCodeEntry"
      :autofocus-on-input="qrSearchParams.autofocusOnInput"
      :auto-open-camera="qrSearchParams.autoOpenCamera"
      :continuous-bar-code-reading="qrSearchParams.continuousBarCodeReading"
      :inputmode="inputmode"
      :disabled="disableInput"
      @code-reading="CodeScannerRead"
      @codigo-barras="CodeScannerRead"
    />
  </div>
</template>

<script>
import { defineComponent, nextTick } from 'vue';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { sleep } from '@/js/utils/sleep';
import TheNavbar from '../TheNavbar.vue';
import UCCodeScanner from './UCCodeScanner.vue';

/** @import { HTMLAttributes, PropType } from 'vue' */
/** @import { SPApp } from '@erpagroapp/types' */

export default defineComponent({
  name: 'UCSearchEntityERP',
  components: {
    TheNavbar,
    UCCodeScanner,
  },
  props: {
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    defaultValue: {
      type: /** @type {PropType<Record<string, any> | null>} */ (Object),
      default: null,
    },
    defaultEtitiesList: {
      type: /** @type {PropType<any[] | null>} */ (
        Array
      ),
      default: null,
    }, // Lista de entidades que se cargan por defecto
    emitEvetChangeDefaultValue: { type: Boolean, default: false },
    searchText: { type: String, default: '' },
    searchCancellationText: { type: String, default: '' },
    searchByCode: { type: String, default: '' },
    endPointForCodeSearch: { type: Function, default: null },
    endPointForList: { type: Function, default: null },
    // debemos pasarle una estructura como la de abajo, con el primer filtro llamado "filtro"
    procedureForSearch: {
      type: /** @type {PropType<SPApp | null>} */ (Object),
      default: null,
    },
    /* pruebaProcedure: {
        NombreSP: 'APPERPAGRO_AlmacenesXIdGrupoEmpresarialXUbicacion',
        Parametros: [{ NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: '' },
          { NombreParametro: 'idsUbicacion', Valor: '' }],
        EntidadMapear: 'AlmacenJSON',
      }, */
    searchNotFoundText: { type: String, default: '' },
    propertyEntityShownInput: { type: Array, default: () => ['Codigo'] },
    propertyEntityShownListTitle: { type: Array, default: () => [] },
    propertyEntityShownListSubtitle: { type: Array, default: () => [] },
    prePropertyEntityShownListSubtitle: { type: Array, default: () => [] }, // Estos son los nombres de los campos que van antes de los valores de los subtitulos tenemos que tener tantos nombre como valores le pasemos en subtitulos
    nextAndPreviousButtonsShown: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    noOpacityDisabled: { type: Boolean, default: false },
    disabledQr: { type: Boolean, default: false },
    minTextSearch: { type: Number, default: 0 },
    autofocusOnDeselection: { type: Boolean, default: false },
    autoFocusOnEmptySearchResult: { type: Boolean, default: false },
    qrSearchShow: { type: Boolean, default: false },
    separationCharacter: { type: Array, default: () => ['/', '-', ''] },
    subtitleElementUnion: { type: Array, default: () => [] }, // Agrupa los elemento del subtitulo para mostrarlos en la misma columna. Permite solo números pares no podemos unir mas de 2 elementos.
    dontQrSelect: { type: Boolean, default: false },
    showTotalElements: { type: Boolean, default: false }, // Propiedad para mostrar el total de elementos y los que tenemos cargados actualmente
    qrSearchParams: {
      type: Object,
      default: () => (
        {
          active: true,
          showInputButton: true,
          fabButtonShow: false,
          barcodeSearchPrefix: '', // Permite que las busquedas se realicen añadiendo un prefijo al inicio ejemplo: code:000001
          autoOpenCamera: true,
          autofocusOnInput: false,

        }),
    },
    searchIn: { type: Array, default: () => ['.item-title', '.subtitle0'] },
    useMoodColumnsSubtitle: { type: Boolean, default: false }, // si lo ponemos a true se concatenan los titulos que queramos
    elementsPerPage: { type: Number, default: 20 }, // Amount of elements that will be displayed per page, if showPaginationBar is true
    showPaginationBar: { type: Boolean, default: false }, // Shows pagination bar at the bottom
    multiSelection: { type: Boolean, default: false }, // Allows multi-selection of elements

    /**
     * Allows to show in the input how many items are selected.
     * Must be used with multi selection, because when items are still not loaded,
     * it will show how many items are selected
     */
    multiSelectionSelectedNum: { type: Number, default: 0 },

    focusOnInput: { type: Boolean, default: false }, // Permite que se autoenfoque dependiento del parametro
    showBtnSearch: { type: Boolean, default: true }, // si esta a false no se muestra el icono de busqueda y se convierte en un input nomral pero manteniendo el diseño
    showBar: { type: Boolean, default: true }, // mostrar la barra de busqueda
    keepFieldValue: { type: Boolean, default: false }, // Mantiene el estado del campo cuando no se encuentran resultados al hacer la busqueda
    inputmode: {
      type: /** @type {PropType<HTMLAttributes['inputmode']>} */ (
        String
      ),
      default: undefined,
    },
    required: { type: Boolean, default: false }, // Muestra un asterisco rojo al lado del titulo para indicar que es requerido
    controlBlur: { type: Boolean, default: false }, // controla que al salir del input si se le olvida al usuario pulsar sobre la busqueda o al enter realice la busqueda con el valor escrito en el input
    /**
     * Controla si se muestra el texto "No hay resultados para tu búsqueda...".
     * Esto puede servir para cuando se desea no mostrar el texto,
     * como, por ejemplo, en la lectura de Partidas en Gestión de subasta, si esta ya está en el listado.
     */
    supressNotFoundText: { type: Boolean, default: false },
  },

  emits: [
    'open-popup-search-entities',
    'close-popup-search-entities',
    'qrOpenSearch',
    'qrValue',
    'selected-elements',
    'selection',
    'fieldValue',
    'notFound',
  ],

  data() {
    return {
      popupSearchEntities: false, // establece el popup de Search se encuentra abierto o cerrado
      entityList: null, // Conjunto de entityList disponibles para su selección.
      selection: '', // Entity selected.
      states: {
        INITIAL: 'INITIAL',
        SEARCH: 'SEARCH',
        VALIDATING: 'VALIDATING',
        VALIDATED: 'VALIDATED',
      },
      componentMode: '', // states del componente = states.
      searchFieldValue: '', // Valor que contiene el input
      listItemsShow: null,
      listItemsShowSubtitle: null,
      preListItemsShowSubtitle: [],
      // Propiedades nuevas para la carga dinamica
      items: [],
      loading: false,
      lstElementsRender: null,
      lstFiltrada: [],
      searchTextFilter: '',
      currentPageNum: 1,
      totalPagesNum: 1,
      findPageValue: 1, // Used as value of the input to set new page
      checkedList: [], // elementos seleccionador en la multiseleccion
      disabledButton: false,
      showWarningInput: false,
      /** @type {SPApp | null} */
      procedure: null,
      searching: false,
    };
  },
  computed: {
    inputElementId() {
      return Math.random();
    },
    disableInput() {
      return this.disabled || this.componentMode === this.states.VALIDATED;
    },
  },
  watch: {
    defaultValue(val) {
      if (val != null) {
        this.SelectEntity(val, this.emitEvetChangeDefaultValue);
      } else {
        this.Clear();
      }
    },

    searchByCode(val) {
      if (val != null) {
        this.searchFieldValue = val;
        this.ValidateEntity();
      }
    },

    popupSearchEntities(val) {
      if (val === true) {
        this.$emit('open-popup-search-entities');
      } else {
        this.$emit('close-popup-search-entities');
      }
    },
    defaultEtitiesList(val) {
      this.entityList = val;
    },
    entityList(val) {
      if (val) {
        this.totalPagesNum = Math.ceil(val.length / this.elementsPerPage);
      }
    },
    propertyEntityShownListTitle(val) {
      if (val) {
        if (!Array.isArray(this.propertyEntityShownListTitle)) {
          this.listItemsShow = [val];
        } else {
          this.listItemsShow = val;
        }
      }
    },
    propertyEntityShownListSubtitle(val) {
      if (val) {
        if (!Array.isArray(this.propertyEntityShownListSubtitle)) {
          this.listItemsShowSubtitle = [val];
        } else {
          this.listItemsShowSubtitle = val;
        }
      }
    },
    procedureForSearch(val) {
      this.procedure = val;
    },
  },

  mounted() {
    this.DetectEventScroll();
    this.eventInputBlur();
    this.SearchMode();
    this.popupSearchEntities = false;
    if (!Array.isArray(this.propertyEntityShownListTitle)) {
      this.listItemsShow = [this.propertyEntityShownListTitle];
    } else {
      this.listItemsShow = this.propertyEntityShownListTitle;
    }
    if (!Array.isArray(this.propertyEntityShownListSubtitle)) {
      this.listItemsShowSubtitle = [this.propertyEntityShownListSubtitle];
    } else {
      this.listItemsShowSubtitle = this.propertyEntityShownListSubtitle;
    }
    if (this.prePropertyEntityShownListSubtitle.length !== this.propertyEntityShownListSubtitle.length) {
      this.preListItemsShowSubtitle = [];
      for (let i = 0; i < this.propertyEntityShownListSubtitle.length; i += 1) {
        this.preListItemsShowSubtitle.push('');
      }
    } else {
      // this.preListItemsShowSubtitle = this.prePropertyEntityShownListSubtitle;
      for (let i = 0; i < this.prePropertyEntityShownListSubtitle.length; i += 1) {
        const element = this.prePropertyEntityShownListSubtitle[i];
        this.preListItemsShowSubtitle.push(element);
      }
    }

    if (this.multiSelectionSelectedNum >= 1) {
      this.HandleMultiSelectionSelectedNum();
    }

    if (this.defaultValue != null) {
      this.SelectEntity(
        this.defaultValue,
        this.emitEvetChangeDefaultValue,
      );
    }
    this.procedure = this.procedureForSearch;
  },
  methods: {
    DetectEventScroll() {
      Log(this, this.DetectEventScroll.name);
      const pages = document.querySelectorAll('.page-content');

      pages.forEach((page) => {
        page.addEventListener('scroll', () => {
          nextTick(() => {
            const actual = this.GetPopupPageContent();
            if (actual != null) {
              this.UpdateCurrentPageNumber(actual);
              const totalHeight = actual.scrollHeight;
              const scrollPosition = actual.scrollTop + actual.clientHeight;

              // If user has scrolled to the bottom, try to load more items
              // Ampliamos el umbral de detección del final del contenido con un margen de 5 pixeles
              if (Math.ceil(scrollPosition) >= totalHeight - 5 && !this.loading) {
                this.LoadMoreItems();
              }
            }
          });
        });
      });
    },
    eventInputBlur() {
      Log(this, this.eventInputBlur.name);
      if (this.controlBlur) {
        const input = document.getElementById(this.inputElementId);
        input?.addEventListener('blur', () => {
          if (this.searchFieldValue && !this.searching) {
            this.ValidateEntity(this.autoFocusOnEmptySearchResult);
          }
        });
      }
    },
    HandleMultiSelectionSelectedNum() {
      Log(this, this.HandleMultiSelectionSelectedNum.name);

      if (this.multiSelectionSelectedNum >= 1) {
        if (this.multiSelectionSelectedNum === 1) {
          this.searchFieldValue = this.$t('searchEntityERP.multiSelection.searchField.single');
        } else if (this.multiSelectionSelectedNum > 1) {
          this.searchFieldValue = this.$t('searchEntityERP.multiSelection.searchField.multiple', {
            count: this.multiSelectionSelectedNum,
          });
        }

        this.componentMode = this.states.VALIDATED;
      }
    },
    async LoadMoreItems(val = 0) {
      Log(this, this.LoadMoreItems.name);
      this.loading = true;
      const filtrando = this.lstFiltrada.length > 0 || this.searchTextFilter !== '';
      const newElements = this.items.length + (val || this.elementsPerPage);

      if (!filtrando) {
        if (this.entityList != null) {
          const nextItems = this.entityList.slice(this.items.length, newElements);
          nextItems.forEach((element) => {
            this.items.push(element);
          });
        }
      } else if (this.lstFiltrada != null && filtrando) {
        const nextItems = this.lstFiltrada.slice(this.items.length, newElements);
        nextItems.forEach((element) => {
          this.items.push(element);
        });
      }

      this.loading = false;
    },
    async RenderVirtualList(items) {
      Log(this, this.RenderVirtualList.name);
      const lstElementos = [];
      const elemento = {
        eRend: null,
        eNormal: null,
      };
      items.forEach((item) => {
        const container = document.createElement('div');
        const titulo = document.createElement('div');
        titulo.innerText = this.GetPropertyEntityShownListTitle(item);
        titulo.classList.add('.item-title');
        container.appendChild(titulo);
        const subtitulos = this.GetPropertyEntityShownListSubtitle(item);
        for (let i = 0; i < subtitulos.length; i += 1) {
          const result = subtitulos[i];
          const sub = document.createElement('div');
          sub.innerText = result;
          sub.classList.add(`.subtitle${i}`);
          container.appendChild(sub);
        }
        elemento.eRend = container;
        elemento.eNormal = item;
        lstElementos.push({ ...elemento });
      });
      this.lstElementsRender = lstElementos;
    },
    ChangeSearch(value) {
      Log(this, this.ChangeSearch.name);
      this.searchTextFilter = value;
      this.lstFiltrada = [];
      this.items = [];

      // Reset scroll, to avoid loading all elements to the scroll position
      // we were at before
      const pageContent = this.GetPopupPageContent();
      if (pageContent) {
        pageContent.scrollTop = 0;
      }

      if (value !== '') {
        this.lstElementsRender.forEach((i) => {
          for (let j = 0; j < this.searchIn.length; j += 1) {
            const element = this.searchIn[j];
            const items = i.eRend.getElementsByClassName(element.toString());

            if (items.length > 0) {
              if (items[0].textContent.toUpperCase().includes(value.toUpperCase())) {
                this.lstFiltrada.push(i.eNormal);
                break;
              }
            }
          }
        });

        this.LoadMoreItems();
        this.currentPageNum = this.lstFiltrada.length > 0 ? 1 : 0;
        this.totalPagesNum = Math.ceil(this.lstFiltrada.length / this.elementsPerPage);
      } else {
        const nextItems = this.entityList.slice(0, this.elementsPerPage);
        nextItems.forEach((element) => {
          this.items.push(element);
        });
        this.currentPageNum = this.entityList.length > 0 ? 1 : 0;
        this.totalPagesNum = Math.ceil(this.entityList.length / this.elementsPerPage);
      }
      this.findPageValue = this.currentPageNum;
    },

    /**
     * @public
     * @returns {void}
     */
    ShowWarning() {
      Log(this, this.ShowWarning.name);
      this.showWarningInput = true;
    },

    /**
     * @public
     * @returns {void}
     */
    HideWarning() {
      Log(this, this.HideWarning.name);
      this.showWarningInput = false;
    },

    setCheckboxValue() {
      Log(this, this.setCheckboxValue.name);
      if (this.multiSelection) {
        this.items.forEach((i) => {
          i.checked = false;
        });
      }
    },
    emitFieldValue() {
      this.$emit('fieldValue', this.searchFieldValue);
    },
    ChangeCheckBox(entity) {
      Log(this, this.ChangeCheckBox.name);
      entity.checked = !entity.checked;
      let disabled = true;
      this.items.forEach((item) => {
        if (item.checked) {
          disabled = false;
        }
      });
      this.disabledButton = disabled;
    },

    async GetEntity(showPopupSearchEntities) {
      Log(this, this.GetEntity.name);
      // OPCION 1 --> Busqueda desde EndPoint
      if (this.defaultEtitiesList == null) {
        return new Promise(((resolve, reject) => {
          const self = this;
          HiDialog.Preloader(true, this.searchText, true, this.searchCancellationText);
          if (this.procedure === null) {
            this.endPointForList().then((result) => {
              self.popupSearchEntities = showPopupSearchEntities === undefined ? true : showPopupSearchEntities;
              if (result.Mensaje) {
                self.entityList = JSON.parse(result.Mensaje);
                this.items = [];
                const nextItems = this.entityList.slice(0, this.elementsPerPage);
                nextItems.forEach((element) => {
                  this.items.push(element);
                });
                this.setCheckboxValue();
                self.RenderVirtualList(self.entityList);
                resolve(self.entityList);
              }
              if (result.data) {
                self.entityList = result.data;
                this.items = [];
                const nextItems = this.entityList.slice(0, this.elementsPerPage);
                nextItems.forEach((element) => {
                  this.items.push(element);
                });
                this.setCheckboxValue();
                self.RenderVirtualList(self.entityList);
                resolve(self.entityList);
              }
              // self.entityList = result.data;
              HiDialog.Preloader(false);
            // resolve(result.data);
            })
              .catch((error) => {
                LogError(this, this.GetEntity.name, error);
                HiDialog.Preloader(false);
                HiNotification.Toast(this.$t('common.checkYourConnection'));
                reject(error);
              });
          } else {
            const modifiedProcedureForSearch = this.procedure;
            const parteIncluyendoDosPuntos = modifiedProcedureForSearch.Parametros[0].Valor.substring(0, modifiedProcedureForSearch.Parametros[0].Valor.indexOf(':') + 1);

            modifiedProcedureForSearch.Parametros[0].Valor = parteIncluyendoDosPuntos + this.searchFieldValue;
            callExecuteSPERP(
              modifiedProcedureForSearch.NombreSP,
              modifiedProcedureForSearch.Parametros,
              modifiedProcedureForSearch.EntidadMapear,
            ).then((result) => {
              self.popupSearchEntities = showPopupSearchEntities === undefined ? true : showPopupSearchEntities;
              if (result.data) {
                self.entityList = result.data;
                this.items = [];
                const nextItems = this.entityList.slice(0, this.elementsPerPage);
                nextItems.forEach((element) => {
                  this.items.push(element);
                });
                this.setCheckboxValue();
                self.RenderVirtualList(self.entityList);
                resolve(self.entityList);
              }
              // self.entityList = result.data;
              HiDialog.Preloader(false);
              // resolve(result.data);
            })
              .catch((error) => {
                LogError(this, this.GetEntity.name, error);
                HiDialog.Preloader(false);
                HiNotification.Toast(this.$t('common.checkYourConnection'));
                reject(error);
              });
          }
        }));
      }
      // OPCION 2 --> Busqueda desde una lista de entidades ya cargada en la propiedad defaultEtitiesList.
      return new Promise(((resolve) => {
        const self = this;
        self.popupSearchEntities = showPopupSearchEntities
        === undefined ? true : showPopupSearchEntities;
        self.entityList = self.defaultEtitiesList;
        this.items = [];
        const nextItems = this.entityList.slice(0, this.elementsPerPage);
        nextItems.forEach((element) => {
          this.items.push(element);
        });
        this.setCheckboxValue();
        self.RenderVirtualList(self.entityList);
        resolve(self.entityList);
      }));
    },

    ClickInputButton() {
      Log(this, this.ClickInputButton.name);

      if (this.componentMode === this.states.SEARCH || this.componentMode === this.states.VALIDATING) {
        this.SearchInputSelection();
      } else if (this.componentMode === this.states.VALIDATED) {
        this.Clear(this.autofocusOnDeselection);
      }
    },

    SearchInputSelection() {
      Log(this, this.SearchInputSelection.name);

      if (this.searchFieldValue.length < this.minTextSearch) {
        HiNotification.Toast(this.$t('searchEntityERP.minTextSearchToastText'));
        this.SetFocusOnInputElement();
        return;
      }
      if (this.searchFieldValue === '') {
        this.GetEntity();
      } else {
        this.ValidateEntity();
      }
    },
    /** @public */
    setInputValue(value) {
      Log(this, this.setInputValue.name);
      this.searchFieldValue = value;
    },
    /** @public */
    SelectEntity(entity, emitEvent, selectDefault) {
      Log(this, this.SelectEntity.name);
      if (selectDefault) {
        return;
      }
      this.popupSearchEntities = false;
      this.selection = entity;
      this.searchFieldValue = '';

      for (let i = 0; i < this.propertyEntityShownInput.length; i += 1) {
        if (this.propertyEntityShownInput[i].includes('.')) {
          const elements = this.propertyEntityShownInput[i].split('.');
          const lastElement = elements.pop();
          let currentItem = entity;

          for (const element of elements) {
            currentItem = currentItem[element];
          }

          this.searchFieldValue += currentItem[lastElement];
        } else {
          this.searchFieldValue += entity[this.propertyEntityShownInput[i]];
        }

        if (i < this.propertyEntityShownInput.length - 1) {
          if (this.separationCharacter[i]) {
            this.searchFieldValue += this.separationCharacter[i];
          } else {
            this.searchFieldValue += ' ';
          }
        }
      }

      // if (this.propertyEntityShownInput.length > 1) {
      //   this.propertyEntityShownInput.forEach((p, index) => {
      //     if (p.includes('.')) {
      //       const element = p.split('.');
      //       if (element.length > 2) {
      //         this.searchFieldValue += entity[element[0]][element[1]][element[2]] + (this.separationCharacter[index] !== undefined ? this.separationCharacter[index].toString() : '');
      //       } else {
      //         this.searchFieldValue += entity[element[0]][element[1]] + (this.separationCharacter[index] !== undefined ? this.separationCharacter[index].toString() : '');
      //       }
      //     } else {
      //       this.searchFieldValue += entity[p].toString() + (this.separationCharacter[index] !== undefined ? this.separationCharacter[index] : '');
      //     }
      //   });
      //   /*
      //   if (this.searchFieldValue.length > 0) {
      //     this.searchFieldValue = this.searchFieldValue
      //       .substring(0, this.searchFieldValue.length - 3);
      //   }
      //   */
      // } else {
      //   this.searchFieldValue = entity[this.propertyEntityShownInput[0]];
      // }

      this.ValidatedMode(emitEvent);
    },
    /** @public */
    GetInputValue() {
      Log(this, this.GetInputValue.name);
      return this.searchFieldValue;
    },

    /**
     * @public
     * @param {any} valor
     * @returns {void}
     */
    SetInputValue(valor) {
      Log(this, this.GetInputValue.name);
      this.searchFieldValue = valor;
    },

    GetPropertyEntityShownListTitle(entity) {
      let txtResult = '';

      for (let i = 0; i < this.listItemsShow.length; i += 1) {
        if (this.listItemsShow[i].includes('.')) {
          const elements = this.listItemsShow[i].split('.');
          const lastElement = elements.pop();
          let currentItem = entity;

          for (const element of elements) {
            currentItem = currentItem[element];
          }

          txtResult += currentItem[lastElement];
        } else {
          txtResult += entity[this.listItemsShow[i]];
        }

        if (i < this.listItemsShow.length - 1) {
          if (this.separationCharacter[i]) {
            txtResult += this.separationCharacter[i];
          } else {
            txtResult += ' ';
          }
        }
      }
      // for (let i = 0; i < this.listItemsShow.length; i += 1) {
      //   // const element = this.propertyEntityShownListTitle[i];
      //   if (this.listItemsShow[i].includes('.')) {
      //     const element = this.listItemsShow[i].split('.');
      //     // por ahora solo permite cuatro niveles los titulos
      //     if (element.length === 4) {
      //       if (this.listItemsShow.length <= 1) {
      //         txtResult += `${entity[element[0]][element[1]][element[2]][element[3]]}`;
      //       } else {
      //         txtResult += entity[element[0]][element[1]][element[2][element[3]]] + this.separationCharacter[i];
      //       }
      //     } else if (element.length === 3) {
      //       if (this.listItemsShow.length <= 1) {
      //         txtResult += `${entity[element[0]][element[1]][element[2]]}`;
      //       } else {
      //         txtResult += entity[element[0]][element[1]][element[2]] + this.separationCharacter[i];
      //       }
      //     } else if (element.length === 2) {
      //       if (this.listItemsShow.length <= 1) {
      //         txtResult += `${entity[element[0]][element[1]]}`;
      //       } else {
      //         txtResult += entity[element[0]][element[1]] + this.separationCharacter[i];
      //       }
      //     }
      //   } else if (this.listItemsShow.length <= 1) {
      //     txtResult += entity[this.listItemsShow[i]];
      //   } else {
      //     txtResult += entity[this.listItemsShow[i]] + this.separationCharacter[i];
      //   }
      // }
      return txtResult;
    },

    GetPropertyEntityShownListSubtitle(entity) {
      // Log(this, this.GetPropertyEntityShownListSubtitle.name);
      const txtResult = [];
      // los subtitulos solo permiten 4 niveles en el arbol del entity
      for (let i = 0; i < this.listItemsShowSubtitle.length; i += 1) {
        if (this.listItemsShowSubtitle[i].includes('.')) {
          const element = this.listItemsShowSubtitle[i].split('.');

          if (element.length === 4) {
            let aniadido = false;
            this.subtitleElementUnion.forEach((e) => {
              if ((i - 1) === Number(e)) {
                txtResult[i - 1] += this.separationCharacter[1] + entity[element[0]][element[1]][element[2]][element[3]];
                aniadido = true;
              }
            });
            if (!aniadido) {
              txtResult[i] = entity[element[0]][element[1]][element[2]][element[3]];
            }
          } else if (element.length === 3) {
            let aniadido = false;
            this.subtitleElementUnion.forEach((e) => {
              if ((i - 1) === Number(e)) {
                txtResult[i - 1] += this.separationCharacter[1] + entity[element[0]][element[1]][element[2]];
                aniadido = true;
              }
            });
            if (!aniadido) {
              txtResult[i] = entity[element[0]][element[1]][element[2]];
            }
          } else if (element.length === 2) {
            let aniadido = false;
            this.subtitleElementUnion.forEach((e) => {
              if ((i - 1) === Number(e)) {
                txtResult[i - 1] += this.separationCharacter[1] + entity[element[0]][element[1]];
                aniadido = true;
              }
            });
            if (!aniadido) {
              txtResult[i] = entity[element[0]][element[1]];
            }
          }
        } else {
          let aniadido = false;
          this.subtitleElementUnion.forEach((e) => {
            if ((i - 1) === Number(e)) {
              txtResult[i - 1] += this.separationCharacter[1] + entity[this.listItemsShowSubtitle[i]];
              aniadido = true;
            }
          });
          if (!aniadido) {
            txtResult[i] = entity[this.listItemsShowSubtitle[i]];
          }
        }
      }
      return txtResult;
    },

    async ValidateEntity(autoFocusOnEmptySearchResult) {
      Log(this, this.ValidateEntity.name);
      this.selection = null;
      this.searching = true;
      this.RemoveFocusActiveElement();
      const self = this;
      // OPCION 1 --> Busqueda desde EndPoint
      if (this.defaultEtitiesList == null) {
        HiDialog.Preloader(true, this.searchText, true, this.searchCancellationText);
        self.componentMode = self.states.VALIDATING;
        if (this.procedure === null) {
          this.endPointForCodeSearch(this.searchFieldValue).then((result) => {
            if (result === null) {
              this.searching = false;
              return;
            }

            if (result.Valor === false) {
              this.$emit('notFound', this.searchFieldValue);
              if (!this.supressNotFoundText) {
                HiNotification.Toast(this.$t('searchEntityERP.noResultsToastText'));
              }
              if (autoFocusOnEmptySearchResult) {
                sleep(100).then(() => {
                  self.SetFocusOnInputElement();
                });
              }
              this.searching = false;
              return;
            }
            if (result.Valor === true && result.Mensaje) {
              if (JSON.parse(result.Mensaje).constructor.name === 'Object') {
                self.SelectEntity(JSON.parse(result.Mensaje), true);
              } else if (JSON.parse(result.Mensaje).constructor === Array && JSON.parse(result.Mensaje).length === 1) {
                self.SelectEntity(JSON.parse(result.Mensaje)[0], true);
              } else {
                self.entityList = JSON.parse(result.Mensaje);
                this.items = [];
                const nextItems = self.entityList.slice(0, self.elementsPerPage);
                nextItems.forEach((element) => {
                  this.items.push(element);
                });
                this.setCheckboxValue();
                self.RenderVirtualList(self.entityList);
                self.popupSearchEntities = true;
              }
              this.searching = false;
              return;
            }

            if (((result.statusText === 'OK' || result.status === 200) && result.data === null) || (result.data.constructor === Array && result.data.length === 0)) {
              this.$emit('notFound', this.searchFieldValue);
              if (!this.supressNotFoundText) {
                HiNotification.Toast(this.$t('searchEntityERP.noResultsToastText'));
              }
              if (autoFocusOnEmptySearchResult) {
                sleep(100).then(() => {
                  self.SetFocusOnInputElement();
                });
              }
              this.searching = false;
              return;
            }
            const { data } = result;
            // Solo encontramos una coincidencia de Entidad
            if (data.constructor.name === 'Object' || (data.constructor === Array && data.length === 1)) {
              if (data.constructor === Array) {
                self.SelectEntity(data[0], true);
              } else {
                self.SelectEntity(data, true);
              }
            } else {
              self.entityList = data;
              this.items = [];
              const nextItems = this.entityList.slice(0, this.elementsPerPage);
              nextItems.forEach((element) => {
                this.items.push(element);
              });
              this.setCheckboxValue();
              self.RenderVirtualList(self.entityList);
              self.popupSearchEntities = true;
            }
          })
            .catch((error) => {
              Log(self, this.ValidateEntity.name, error);
              HiNotification.Toast(this.$t('common.checkYourConnection'));
            })
            .finally(() => {
              HiDialog.Preloader(false);
            });
        } else {
          const modifiedProcedureForSearch = this.procedure;
          const parteIncluyendoDosPuntos = modifiedProcedureForSearch.Parametros[0].Valor.substring(0, modifiedProcedureForSearch.Parametros[0].Valor.indexOf(':') + 1);
          modifiedProcedureForSearch.Parametros[0].Valor = parteIncluyendoDosPuntos + this.searchFieldValue;
          callExecuteSPERP(
            modifiedProcedureForSearch.NombreSP,
            modifiedProcedureForSearch.Parametros,
            modifiedProcedureForSearch.EntidadMapear,
          ).then((result) => {
            HiDialog.Preloader(false);
            if (result.data.length !== 0) {
              if (result.data.length === 1) {
                self.SelectEntity(result.data[0], true);
              } else {
                self.entityList = result.data;
                this.items = [];
                const nextItems = self.entityList.slice(0, self.elementsPerPage);
                nextItems.forEach((element) => {
                  this.items.push(element);
                });
                this.setCheckboxValue();
                self.RenderVirtualList(self.entityList);
                self.popupSearchEntities = true;
              }
              this.searching = false;
              return;
            }
            if (((result.statusText === 'OK' || result.status === 200) && result.data === null) || (result.data.constructor === Array && result.data.length === 0)) {
              this.$emit('notFound', this.searchFieldValue);
              if (!this.supressNotFoundText) {
                HiNotification.Toast(this.$t('searchEntityERP.noResultsToastText'));
              }
              // Cuando se realiza una busqueda y no hay resultado se reseatea el valor del input
              if (!this.keepFieldValue) {
                this.searchFieldValue = '';
              }
              if (autoFocusOnEmptySearchResult) {
                sleep(100).then(() => {
                  self.SetFocusOnInputElement();
                });
              }
            }
          })
            .catch((error) => {
              Log(self, this.ValidateEntity.name, error);
              HiDialog.Preloader(false);
              HiNotification.Toast(this.$t('common.checkYourConnection'));
            });
        }
      } else { // OPCION 2 --> Busqueda desde una lista de entidades ya cargada en la propiedad defaultEtitiesList.
        let result = [];
        if (self.propertyEntityShownInput.length > 1) {
          result = self.defaultEtitiesList.filter(
            (element) => element[self.propertyEntityShownInput[0]]
              .toLowerCase().includes(self.searchFieldValue.toLowerCase())
              || element[self.propertyEntityShownInput[1]]
                .toLowerCase().includes(self.searchFieldValue.toLowerCase()),
          );
        } else {
          result = self.defaultEtitiesList.filter(
            (element) => element[self.propertyEntityShownInput[0]]
              .toLowerCase().includes(self.searchFieldValue.toLowerCase()),
          );
        }
        // HiDialog.Preloader(false);
        if (result.length === 0) {
          this.$emit('notFound', this.searchFieldValue);
          if (!this.supressNotFoundText) {
            HiNotification.Toast(this.$t('searchEntityERP.noResultsToastText'));
          }
          if (autoFocusOnEmptySearchResult) {
            sleep(100).then(() => {
              self.SetFocusOnInputElement();
            });
          }
          this.searching = false;
          return;
        }
        // Solo encontramos una coincidencia de Entidad
        if (result.length === 1) {
          self.SelectEntity(result[0], true);
        } else {
          self.entityList = result;
          this.items = [];
          const nextItems = self.entityList.slice(0, self.elementsPerPage);
          nextItems.forEach((element) => {
            this.items.push(element);
          });
          this.setCheckboxValue();
          self.RenderVirtualList(self.entityList);
          self.popupSearchEntities = true;
        }
        this.searching = false;
      }
      this.searching = false;
    },

    /**
     * @public
     * @param {object} options
     * @param {boolean} [options.autoFocus]
     * @param {boolean} [options.noEmitEvent]
     * @param {boolean} [options.keepSelection]
     * @returns {Promise<void>}
     */
    async Clear({
      autoFocus = false,
      noEmitEvent = false,
      keepSelection = false,
    } = {}) {
      Log(this, this.Clear.name);
      this.searchTextFilter = '';
      this.currentPageNum = 1;
      this.findPageValue = 1;

      if (!keepSelection) {
        this.searchFieldValue = '';
        this.selection = '';
        this.SearchMode(noEmitEvent);
      }

      if (autoFocus) {
        await sleep(100);
        this.SetFocusOnInputElement();
      }
    },

    RemoveFocusActiveElement() {
      Log(this, this.RemoveFocusActiveElement.name);
      const elementoActivo = document.activeElement;
      elementoActivo.blur();
    },
    PreviousEntity() {
      Log(this, this.PreviousEntity.name);
      if (this.entityList === null) {
        this.GetEntity(false).then(() => {
          if (this.entityList.length > 0) {
            this.SelectEntity(this.entityList[this.entityList.length - 1], true);
          }
        });
        return;
      }
      if (this.selection != null && this.entityList.length > 0) {
        // const position = this.entityList.indexOf((e) => e.Id === this.selection.Id);
        const position = this.entityList.map((e) => e.Id).indexOf(this.selection.Id);
        if (position - 1 > 0) {
          this.SelectEntity(this.entityList[position - 1], true);
        } else {
          this.SelectEntity(this.entityList[this.entityList.length - 1], true);
        }
      }
    },
    NextEntity() {
      Log(this, this.NextEntity.name);
      if (this.entityList === null) {
        this.GetEntity(false).then(() => {
          if (this.entityList.length > 0) {
            this.SelectEntity(this.entityList[0], true);
          }
        });
        return;
      }
      if (this.selection != null && this.entityList.length > 0) {
        const position = this.entityList.map((e) => e.Id).indexOf(this.selection.Id);
        if (position + 1 < this.entityList.length - 1) {
          this.SelectEntity(this.entityList[position + 1], true);
        } else {
          this.SelectEntity(this.entityList[0], true);
        }
      }
    },

    /**
     * @public
     * @returns {void}
     */
    SetFocusOnInputElement() {
      Log(this, this.SetFocusOnInputElement.name);
      document.getElementById(this.inputElementId).focus();
    },

    /**
     * @public
     * @returns {void}
     */
    OpenQRSearch() {
      Log(this, this.OpenQRSearch.name);
      this.$emit('qrOpenSearch', true);
      this.$refs.componentUCcodeScanner.Open();
    },

    CodeScannerRead(val) {
      Log(this, this.CodeScannerRead.name);
      if (this.dontQrSelect) {
        this.$emit('qrValue', val);
      } else {
        this.searchFieldValue = this.qrSearchParams.barcodeSearchPrefix !== undefined ? this.qrSearchParams.barcodeSearchPrefix + val : val;
        this.ValidateEntity(false);
      }
    },

    GetPopupPageContent() {
      // Log(this, this.GetPopupPageContent.name);
      const elements = document.querySelectorAll('#search-entity-page-content');
      return elements[elements.length - 1];
    },

    UpdateCurrentPageNumber(pageContent) {
      // Log(this, this.UpdateCurrentPageNumber.name);
      const totalHeight = pageContent.scrollHeight;
      const pagesLoaded = (this.items.length / this.elementsPerPage);
      const pageSize = (totalHeight / pagesLoaded) - 60 - 1;
      const scrollTop = pageContent.scrollTop ? pageContent.scrollTop : 1;
      this.currentPageNum = Math.ceil(scrollTop / pageSize);
      this.findPageValue = this.currentPageNum;
    },

    async ChangeItemsPage(next) {
      Log(this, this.ChangeItemsPage.name);

      const pageContent = this.GetPopupPageContent();
      if (!pageContent) {
        return;
      }

      const totalHeight = pageContent.scrollHeight;
      const pagesLoaded = (this.items.length / this.elementsPerPage);
      const pageSize = Math.ceil((totalHeight / pagesLoaded) - 60);
      if (next) {
        if (this.currentPageNum === pagesLoaded) {
          // Load the next page before scrolling down
          await this.LoadMoreItems();
        }
        pageContent.scrollTop = pageSize * this.currentPageNum;
      } else {
        let newVal = (pageSize * (this.currentPageNum - 1)) - pageSize;
        if (newVal < 0) {
          newVal = 0;
        }
        pageContent.scrollTop = newVal;
      }
      this.UpdateCurrentPageNumber(pageContent);
    },

    async SetNewItemsPage(val) {
      Log(this, this.SetNewItemsPage.name);
      if (val <= 0 || val > this.totalPagesNum) {
        HiNotification.Toast(this.$t('searchEntityERP.invalidPageToastText'));
        return;
      }
      let pagesLoaded = (this.items.length / this.elementsPerPage);
      if (val > pagesLoaded) {
        // Load the new elements first
        const difference = val - pagesLoaded;
        const newElements = difference * this.elementsPerPage;
        await this.LoadMoreItems(newElements);
      }

      const pageContent = this.GetPopupPageContent();
      if (!pageContent) {
        return;
      }

      this.currentPageNum = val;
      this.findPageValue = val;

      const totalHeight = pageContent.scrollHeight;
      pagesLoaded = (this.items.length / this.elementsPerPage);
      const pageSize = Math.ceil((totalHeight / pagesLoaded) - 60);
      // Scroll to the new page
      pageContent.scrollTop = this.currentPageNum === 1 ? 0 : (pageSize * (this.currentPageNum - 1));
    },
    SelectedElements() {
      Log(this, this.SelectedElements.name);

      this.popupSearchEntities = false;
      this.checkedList = this.entityList.filter((item) => item.checked);

      if (this.checkedList.length === 1) {
        this.searchFieldValue = this.$t('searchEntityERP.multiSelection.searchField.single');
      } else if (this.checkedList.length > 1) {
        this.searchFieldValue = this.$t('searchEntityERP.multiSelection.searchField.multiple', {
          count: this.checkedList.length,
        });
      }

      this.componentMode = this.states.VALIDATED;
      this.$emit('selected-elements', this.checkedList);
    },

    ValidatingMode() {
      Log(this, this.ValidatingMode.name);
      this.componentMode = this.states.VALIDATING;
      this.$emit('selection', null);
    },

    HandleInputClick() {
      Log(this, this.HandleInputClick.name);

      // A short way to select another entity (instead of clicking X and then search)
      if (this.selection) {
        this.GetEntity();
      }
    },

    SearchMode(noEmitEvent) {
      Log(this, this.SearchMode.name);

      if (!noEmitEvent) {
        if (!this.multiSelection) {
          this.$emit('selection', null);
        }

        if (this.multiSelection && this.componentMode === this.states.VALIDATED) {
          this.checkedList = [];
          this.$emit('selected-elements', []);
        }
      }

      this.componentMode = this.states.SEARCH;
    },

    ValidatedMode(emitEvent) {
      Log(this, this.ValidatedMode.name);
      this.componentMode = this.states.VALIDATED;
      if (emitEvent) {
        this.$emit('selection', this.selection);
      }
    },
  },
});
</script>

<style lang="scss">
.content-searcher-erp {
  display: flex;
  align-items: center;

  &__input {
    width: 100%;

    // margin: 0 5px;
  }

  &__arrow-btn {
    width: var(--f7-input-height);
    height: var(--f7-input-height);
    background-color: var(--his-steel-blue);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }

  .content-search-input {
    display: flex;
    flex-direction: row;
    background-color: var(--search-input-bg-color);
    border-radius: var(--search-input-border-radius);
    border: var(--search-input-border);
    box-sizing: border-box;

    input {
      width: 100%;
      height: var(--search-input-height);
      color: var(--search-input-color);
      font-size: var(--search-input-font-size);
      padding: var(--search-input-padding);

      &.truncate {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .input-search {
      cursor: pointer;
      width: calc(100% - 30px);

      input[disabled] {
        pointer-events: none;
      }
    }

    .input-search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      box-sizing: border-box;
      min-width: var(--search-btn-min-width);
      border-left: var(--search-btn-border-left);
      background: var(--search-btn-bg-color);
      border-top-right-radius: 7px;
      border-bottom-right-radius: 7px;
      cursor: pointer;

      &__search {
        width: var(--search-btn-search-img-size);
        height: var(--search-btn-search-img-size);
      }

      &__cancel {
        width: var(--search-btn-cancel-img-size);
        height: var(--search-btn-cancel-img-size);
      }
    }
  }
}

.content-searcher-titulo {
  color: var(--search-title-color);
  font-size: var(--search-title-font-size);
  font-weight: var(--search-title-weight);
  margin: var(--search-title-margin);
  padding: var(--search-title-padding);
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
}

.disabled-component-no-opacity {
  pointer-events: none;
}

.content-searcher-erp-group {
  display: contents;
  width: 100%;
}

.div-qr-search {
  border: 1px solid var(--his-silver);
  background: var(--his-tierra-white);
  border-radius: 8px;
  margin-right: 5px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 1px;
  padding-right: 4px;
  padding-left: 15px;
  margin-left: 10px;
}

.subtitle0 {
  font-size: 14px;
  width: 90%;
}

.subtitle1 {
  font-size: 14px;
  width: 90%;
}

.subtitle2 {
  font-size: 14px;
  width: 90%;
}

.subtitle3 {
  font-size: 14px;
  width: 90%;
}

.subtitle-box {
  // redifinir de esta forma si queremos columnas

  /* display: flex;
  flex-wrap: wrap; */
}

.subtitle-box-column {
  display: flex;
  flex-wrap: wrap;
}

.subtitle-prefix {
  // font-weight: 600;
  font-size: 14px;

  // si es modo columna redifinir y quitar el width
  width: 110px;
}

.subtitle-prefix-column {
  font-weight: 600;
  font-size: 14px;
}

.subtitle-element-column {
  flex-direction: column;
  width: 190px;
}

.subtitle-element {
  // para las columnas redifinir y poner 190px de width yt quitar el display flex
  // width: 190px;
  display: flex;
}

.Search-popup {
  .page {
    .page-content {
      height: 80%;
      margin-top: 111px;
      padding-top: 0;

      .search-list {
        margin-top: 0;

        &__has-bottom-bar {
          padding-bottom: 36px;
        }
      }

      .total-elements-shown {
        padding-bottom: 5px;
      }

      .total-elements-hidden {
        padding-bottom: 20px;
      }

      .container-master {
        position: fixed;
        top: var(--f7-page-navbar-offset);
        z-index: 1000;
        width: 100%;
        background-color: var(--search-input-container-bg-color);

        .cantidad-elementos {
          color: var(--his-oliva);
          margin-top: -12px;
          display: flex;
          flex-direction: row-reverse;
          padding-right: 16px;
          font-size: 11px;
        }

        .container {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          flex-wrap: nowrap;
          margin-top: 8px;
          height: 47px;
          background-color: #fff;
          border-radius: 4px;
          margin-left: calc(var(--f7-typography-margin) / 2);
          margin-right: calc(var(--f7-typography-margin) / 2);

          &__filter-input {
            height: 47px;
            width: 100%;
            margin-right: 0;
            padding-left: 16px;
          }

          &__img {
            height: 47px;
            width: 47px;
            display: flex;
            flex-direction: column;
            align-content: center;
            align-items: center;
            justify-content: center;
          }
        }
      }

      .pagination-bar {
        z-index: 100;
        position: fixed;
        left: 0;
        bottom: 0;
        height: 8%;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        box-shadow: 0 0 5px var(--his-kiwi-pulp);

        &__reversed-image {
          transform: rotate(180deg);
        }

        &__total-pages {
          flex: 0 0 auto;
        }
      }

      .pagination-bar-height {
        z-index: 100;
        position: fixed;
        left: 0;
        bottom: 0;
        height: 14%;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        box-shadow: 0 0 5px var(--his-kiwi-pulp);

        &__reversed-image {
          transform: rotate(180deg);
        }

        &__total-pages {
          flex: 0 0 auto;
        }
      }
    }
  }
}
</style>
